module.exports = __webpack_public_path__ + "static/logo-white-27339443b7ab4e92a81d6fb788db6089.png";